import { KdsInfoIcon, KdsText } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill, RiCloseCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogAssignmentUserProps } from "./OrderItemPageActivityLogAssignmentUser.types";

export const OrderItemPageActivityLogAssignmentUser = ({
  user,
  isUserAssigned,
}: OrderItemPageActivityLogAssignmentUserProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex items-center gap-sp-xs2">
      <KdsText>
        {t("order.myOrdersItemDetails.activityFeed.action.assignedUser.intro", {
          user: user,
        })}
      </KdsText>

      <KdsInfoIcon
        icon={isUserAssigned ? RiCheckboxCircleFill : RiCloseCircleFill}
        state={isUserAssigned ? "success" : "error"}
        label={
          isUserAssigned
            ? t("order.myOrdersItemDetails.activityFeed.action.infoIcon.added")
            : t(
                "order.myOrdersItemDetails.activityFeed.action.infoIcon.deleted"
              )
        }
      />
    </div>
  );
};
